import { render, staticRenderFns } from "./MyPagination.vue?vue&type=template&id=602878f1&scoped=true&"
import script from "./MyPagination.vue?vue&type=script&lang=js&"
export * from "./MyPagination.vue?vue&type=script&lang=js&"
import style0 from "./MyPagination.vue?vue&type=style&index=0&id=602878f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602878f1",
  null
  
)

export default component.exports